import {createContext} from 'react';

import {Stores} from './Root/types';

export default createContext<Stores | undefined>(undefined);
